import React from "react"
import { colors2 } from "oolib"

export const FadeGradientWhenScroll = ({style = {}}) => {
  return (
    <div
      data-hide-on-capture
      style={{
        width: '100%',
        height: '40px',
        position:'sticky',
        left: 0,
        bottom: 0,

        background: `linear-gradient(to top, ${colors2.white}, hsla(0, 0%, 100%, 0))`,
        ...style
      }}
      />
  )
}